"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextFocusableElement = exports.getFocusableElements = void 0;
const getFocusableElements = (refOrElement) => {
    const context = refOrElement instanceof HTMLElement ? refOrElement : refOrElement.current;
    if (!context) {
        return [];
    }
    const focusableElements = Array.from(context === null || context === void 0 ? void 0 : context.querySelectorAll('button:not([disabled]), a:not([tabindex="-1"]), video, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable]'));
    return focusableElements;
};
exports.getFocusableElements = getFocusableElements;
const getNextFocusableElement = (context, direction) => {
    const focusableItems = (0, exports.getFocusableElements)(context);
    const defaultIndex = direction > 0 ? 0 : focusableItems.length - 1;
    if (document.activeElement) {
        const activeIndex = focusableItems.indexOf(document.activeElement);
        const nextIndex = activeIndex + direction;
        const isNoNextIndex = activeIndex === -1 ||
            (direction > 0 ? nextIndex > focusableItems.length - 1 : nextIndex < 0);
        const nextElementIndex = isNoNextIndex ? defaultIndex : nextIndex;
        return focusableItems[nextElementIndex] || focusableItems[defaultIndex];
    }
    return null;
};
exports.getNextFocusableElement = getNextFocusableElement;
//# sourceMappingURL=getNextFocusableElement.js.map